import React from 'react'
import DataTable from 'shared/components/DataTable'

function AssociatedFloorPlans({ pack }) {
  const table = [
    {
      label: 'Floor Plan ID',
      data: (item) => item.id,
    },
    {
      label: 'Floor Plan Name',
      data: (item) =>
        item.display_name || (
          <span title={item.src} className="truncate w-full inline-block">
            {item.src?.split('/').pop()}
          </span>
        ),
    },
    {
      label: 'Spec',
      data: (item) => {
        const items = []
        if (!item.unit_type) {
          return '-'
        }
        if (item.unit_type.number_of_bedrooms) {
          items.push(`${item.unit_type.number_of_bedrooms} Bedroom${item.unit_type.number_of_bedrooms > 1 ? 's' : ''}`)
        }
        if (item.unit_type.number_of_bathrooms) {
          items.push(
            `${item.unit_type.number_of_bathrooms} Bathroom${item.unit_type.number_of_bathrooms > 1 ? 's' : ''}`,
          )
        }
        items.push(`${item.unit_type.size_to_display} ft sq`)
        return items.join(' · ')
      },
    },
    {
      label: 'Property ID',
      data: (item) => (item.unit_type ? item.unit_type.property.id : '-'),
    },
    {
      label: 'Property Name',
      data: (item) => (item.unit_type ? item.unit_type.property.property_name : '-'),
    },
    {
      label: 'Real Estate Compan',
      data: (item) => (item.unit_type ? item.unit_type.property.real_estate_company.company_name : '-'),
    },
  ]

  return (
    <DataTable title={`Associated Floor Plans (${pack.unit_plans.length})`} structure={table} data={pack.unit_plans} />
  )
}

export default AssociatedFloorPlans
